export type ClassificationLevel = "high" | "medium" | "low";
export type GoClassificationLevel = "aa" | "a" | "b" | "c" | "d";

export type BignumberCardStyle = {
  card: string;
  score: string;
  label: string;
  title: string;
};

/** Paridade Admin tabs + cards Geral — light com hex Admin; dark via CSS (.classification-bignumber-*). */
export const bignumberCardStyle = (level: ClassificationLevel): BignumberCardStyle => {
  if (level === "high") {
    return {
      card: "border-[#e53935] bg-[#ffebef] classification-bignumber-high",
      score: "text-[#e53935] classification-bignumber-score",
      label: "text-[#892220] classification-bignumber-label",
      title: "text-[#4d4d4d] classification-bignumber-title",
    };
  }
  if (level === "medium") {
    return {
      card: "border-[#dbbc3b] bg-[#fff7d4] classification-bignumber-medium",
      score: "text-[#dbbc3b] classification-bignumber-score",
      label: "text-[#332b08] classification-bignumber-label",
      title: "text-[#4d4d4d] classification-bignumber-title",
    };
  }
  return {
    card: "border-[#d9d9d9] bg-white classification-bignumber-neutral",
    score: "text-[#4caf50] classification-bignumber-score",
    label: "text-[#1e4620] classification-bignumber-label",
    title: "text-[#4d4d4d] classification-bignumber-title",
  };
};

export const goBignumberCardStyle = (level: GoClassificationLevel): BignumberCardStyle => {
  const normalized = level.toLowerCase() as GoClassificationLevel;
  if (normalized === "aa" || normalized === "a") return bignumberCardStyle("low");
  if (normalized === "b") return bignumberCardStyle("medium");
  return bignumberCardStyle("high");
};

/** Sem classificação (valor "—") — card neutro Admin. */
export const neutralBignumberCardStyle = (): BignumberCardStyle => ({
  card: "border-[#d9d9d9] bg-white classification-bignumber-neutral",
  score: "text-[#4d4d4d] classification-bignumber-score",
  label: "text-[#4d4d4d] classification-bignumber-label",
  title: "text-[#4d4d4d] classification-bignumber-title",
});
